const SendMailView = () => {

    // Test page
    return (
        <div>Lähettää viestiä...</div>
    )
};

export default SendMailView;